import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

const StatutsContext = createContext({ statuts: [], statutMap: {}, refresh: () => {} });

export function StatutsProvider({ children }) {
  const { user } = useAuth();
  const [statuts, setStatuts] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/statuts");
      setStatuts(data.map((s) => ({ code: s.code, label: s.nom, color: s.color, categorie: s.categorie, ordre: s.ordre, actif: s.actif })));
    } catch {
      /* non connecté / erreur : on garde la liste vide */
    }
  }, []);

  useEffect(() => { if (user) refresh(); }, [user, refresh]);

  const statutMap = useMemo(() => Object.fromEntries(statuts.map((s) => [s.code, s])), [statuts]);

  return <StatutsContext.Provider value={{ statuts, statutMap, refresh }}>{children}</StatutsContext.Provider>;
}

export const useStatuts = () => useContext(StatutsContext);
